import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

export default class Header extends Component {
  static propTypes = {
    onLogoutClick: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isFederation: PropTypes.bool.isRequired,
    indexUrl: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = e => {
    const scrollTop = e.srcElement ? e.srcElement.body.scrollTop : e.target.body.scrollTop;

    if (scrollTop > 60) {
      this.setState({ collapse: true });
    } else {
      this.setState({ collapse: false });
    }
  };

  render() {
    const { onLogoutClick, isLoggedIn, isAdmin, isFederation, indexUrl } = this.props;
    const { collapse } = this.state;

    const className = collapse ? 'top-nav-collapse top-menu' : 'top-menu';

    return (
      <Navbar fixedTop className={className}>
        <Navbar.Header>
          <Navbar.Brand>
          {window.cviConfig.cviCountry !== 'Belgium' && (
              <Link to={indexUrl}>
                <div className={`logo-voltiz logo-voltiz-${window.cviConfig.cviCountry}`} />
              </Link>
            )}
            {/* <a href={window.cviConfig.cviUrl} target="_blank">
              {window.cviConfig.cviCountry !== 'Belgium' ? (
                <div className={`logo-cvi logo-cvi-${window.cviConfig.cviCountry}`} />
              ) : (
                <div className={`logo-${window.cviConfig.cviCity}`}/>
              )}
            </a> */}
            <a href="http://thinkcreatix.com" target="_blank">
              <div className="logo-gohealth" />
            </a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          {!isLoggedIn && (
            <Nav pullRight className="links-menu">
              <LinkContainer to="/" className="home">
                <NavItem>Home</NavItem>
              </LinkContainer>
              <LinkContainer to="/login">
                <NavItem>Login</NavItem>
              </LinkContainer>
            </Nav>
          )}

          {isLoggedIn && (
            <Nav pullRight className="links-menu">
              <li onClick={onLogoutClick}>
                <a href="">Logout</a>
              </li>
            </Nav>
          )}

          {isFederation && (
            <Nav pullRight className="links-menu">
              <LinkContainer to="/federation">
                <NavItem>My Entries</NavItem>
              </LinkContainer>
              <LinkContainer to="/federation/additional-horses">
                <NavItem>Additional Horses</NavItem>
              </LinkContainer>
              <LinkContainer to="/federation/all-entries">
                <NavItem>All Entries</NavItem>
              </LinkContainer>
              <li role="presentation">
                <a href={`/${window.cviConfig.guideFileName}`} target="_blank">
                  Guide
                </a>
              </li>
            </Nav>
          )}

          {isAdmin && (
            <Nav pullRight className="links-menu">
              <LinkContainer to="/admin">
                <NavItem>Federations</NavItem>
              </LinkContainer>
              <LinkContainer to="/admin/entries">
                <NavItem>Entries</NavItem>
              </LinkContainer>
              <LinkContainer to="/admin/horses">
                <NavItem>Horses</NavItem>
              </LinkContainer>
            </Nav>
          )}
        </Navbar.Collapse>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header/Header.js